import { usePathname } from 'next/navigation';
import Link from 'next/link';
import { ReactNode } from 'react';

// Utils
import { combineClasses } from '@shared/utils';

// Hooks
import { useScrollIntoView } from '@shared/hooks';
export interface SidebarItemProps {
  icon: ReactNode;
  label: string;
  href: string;
  className?: string;
}
const SidebarItem = ({
  href,
  icon,
  label,
  className
}: SidebarItemProps) => {
  const pathname = usePathname();
  const isActive = pathname.includes(href.replace('.', ''));
  const itemRef = useScrollIntoView<HTMLAnchorElement>(isActive);
  return <div data-testid="sidebar-container" className={combineClasses(className)} data-sentry-component="SidebarItem" data-sentry-source-file="SidebarItem.tsx">
      <Link id="sidebar-item" ref={itemRef} href={href} className={combineClasses('flex-center sm:flex-col gap-2', 'group px-3 py-1 sm:size-[100px] sm:border-y-[5px] sm:p-0 border-transparent', isActive && 'bg-active-nav rounded-md sm:rounded-none sm:bg-transparent border-b-tertiary cursor-default')} data-sentry-element="Link" data-sentry-source-file="SidebarItem.tsx">
        <div className={combineClasses('size-4 sm:size-9 flex-center sm:border-2 sm:border-tertiary sm:rounded-full', '[&_svg]:fill-white', !isActive && 'sm:group-hover:[&_svg]:fill-tertiary', isActive && 'sm:bg-tertiary sm:[&_svg]:fill-primary-900')}>
          {icon}
        </div>
        <span className={combineClasses('sm:truncate text-xs sm:text-4xs text-white uppercase font-medium sm:lowercase sm:font-light', !isActive && 'group-hover:text-tertiary')}>
          {label}
        </span>
      </Link>
    </div>;
};
export default SidebarItem;